import {
  PRESCRIPTION_TYPE_FREE,
  PRESCRIPTION_TYPE_INSURANCE,
  PRESCRIPTION_TYPE_PRIVAT,
} from 'shared/consts'
import type { ErxAndRxProductProps } from 'views/components/organisms/Cart/ProductListing/PriceLabelType'

// Check if label should display "Ihre Zuzahlung"
export const isYourAdditionalPayment = (
  product: ErxAndRxProductProps,
  evaluatedPrescriptionType: string
) => {
  return Boolean(
    (evaluatedPrescriptionType === PRESCRIPTION_TYPE_INSURANCE &&
      product.coPayment &&
      product.coPayment > 0 &&
      product.fixedPriceDifference === 0 &&
      !product.lifeStyleProduct) ||
      (evaluatedPrescriptionType === PRESCRIPTION_TYPE_INSURANCE &&
        product.coPayment === 0 &&
        !product.lifeStyleProduct)
  )
}

// Check if label should display "Ihre Preis"
export const isYourPrice = (
  product: ErxAndRxProductProps,
  evaluatedPrescriptionType: string
) => {
  return Boolean(evaluatedPrescriptionType === PRESCRIPTION_TYPE_FREE)
}

// Check if label should display "Ihre Preis" with fixed price difference tooltip
export const isYourPriceWithFixedPriceDifference = (
  product: ErxAndRxProductProps,
  evaluatedPrescriptionType: string
) => {
  return Boolean(
    evaluatedPrescriptionType === PRESCRIPTION_TYPE_INSURANCE &&
      product.coPayment &&
      product.coPayment > 0 &&
      product.fixedPriceDifference &&
      product.fixedPriceDifference > 0 &&
      !product.lifeStyleProduct
  )
}

// Check if label should display "Ihre Preis" with life style product tooltip
export const isYourPriceWithLifeStyleProduct = (
  product: ErxAndRxProductProps,
  evaluatedPrescriptionType: string
) => {
  return Boolean(
    product.lifeStyleProduct &&
      (evaluatedPrescriptionType === PRESCRIPTION_TYPE_INSURANCE ||
        evaluatedPrescriptionType === PRESCRIPTION_TYPE_PRIVAT)
  )
}

// Check if label should display "Ihre Preis" with bonus tooltip
export const isYourPriceWithBonus = (
  product: ErxAndRxProductProps,
  evaluatedPrescriptionType: string
) => {
  return Boolean(
    !product.lifeStyleProduct &&
      evaluatedPrescriptionType === PRESCRIPTION_TYPE_PRIVAT
  )
}
